var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { setToSessionStorage, getFromSessionStorage, removeFromSessionStorage } from 'utils/sessionStorage';
export var BROADCAST_NAME = 'interTab';
export var INIT = 'init';
export var POST = 'post';
export var SHUTDOWN = 'shutdown';
export var ACTIVATE = 'activate';
export var REGISTER = 'register';
export var interTab = new BroadcastChannel(BROADCAST_NAME);
export var initActiveTab = function (tabId) {
    var activeTabId = getFromSessionStorage('activeTabId')();
    var timestamp = Date.now();
    interTab.postMessage({ type: INIT, tabId: tabId, timestamp: timestamp, targetTab: tabId });
    setToSessionStorage('activityTimestamp')(timestamp);
    if (!activeTabId) {
        setToSessionStorage('activeTabId')(tabId);
    }
};
export var postActiveTabMessage = function (tabId) {
    var timestamp = Date.now();
    interTab.postMessage({ type: POST, tabId: tabId, timestamp: timestamp });
    setToSessionStorage('activityTimestamp')(timestamp);
    setToSessionStorage('activeTabId')(tabId);
};
var activate = function (tabId, activateTab) {
    interTab.postMessage({ type: ACTIVATE, tabId: tabId, targetTab: activateTab });
};
var registerTab = function (tabId, targetTab) {
    interTab.postMessage({ type: REGISTER, tabId: tabId, targetTab: targetTab });
};
export var shutdownTab = function (tabId) {
    var activeTabId = getFromSessionStorage('activeTabId')();
    var openTabs = getFromSessionStorage('openTabs')() || [];
    interTab.postMessage({ type: SHUTDOWN, tabId: tabId });
    if (activeTabId === tabId &&
        openTabs.length &&
        openTabs[openTabs.length - 1]) {
        activate(tabId, openTabs[openTabs.length - 1]);
    }
    removeFromSessionStorage('openTabs');
    removeFromSessionStorage('activeTabId');
    removeFromSessionStorage('activityTimestamp');
};
var addToOpenTabs = function (newTabId) {
    var openTabs = getFromSessionStorage('openTabs')() || [];
    if (!openTabs.includes(newTabId))
        setToSessionStorage('openTabs')(__spreadArray(__spreadArray([], openTabs, true), [newTabId], false));
};
var removeFromOpenTabs = function (removeTabId) {
    var openTabs = getFromSessionStorage('openTabs')() || [];
    if (openTabs.includes(removeTabId))
        setToSessionStorage('openTabs')(openTabs.filter(function (i) { return i !== removeTabId; }));
};
export var onMessage = function (event, tabId) {
    var _a;
    var activityTimestamp = getFromSessionStorage('activityTimestamp')() || Date.now();
    var currentTarget = event === null || event === void 0 ? void 0 : event.currentTarget;
    if ((currentTarget === null || currentTarget === void 0 ? void 0 : currentTarget.name) === BROADCAST_NAME && ((_a = event === null || event === void 0 ? void 0 : event.data) === null || _a === void 0 ? void 0 : _a.tabId)) {
        var _b = event.data, eventTabId = _b.tabId, type = _b.type, timestamp = _b.timestamp, targetTab = _b.targetTab;
        if (type === POST || type === INIT) {
            addToOpenTabs(eventTabId);
            if (activityTimestamp < timestamp) {
                setToSessionStorage('activeTabId')(eventTabId);
            }
            if (type === INIT)
                registerTab(tabId, eventTabId);
        }
        if (type === SHUTDOWN) {
            removeFromOpenTabs(eventTabId);
        }
        if (type === REGISTER) {
            if (targetTab === tabId) {
                addToOpenTabs(eventTabId);
            }
        }
        if (type === ACTIVATE) {
            setToSessionStorage('activeTabId')(targetTab);
        }
    }
};
